/**
 * Thin wrapper around the shared ui-kit agent widget.
 *
 * The widget itself lives at `@isg/ui-kit/js/components/agent-widget.js`
 * so every ISG app mounts the same implementation. This file supplies
 * the customer-certs-specific prompts and labels, then delegates.
 */
import { renderAgentWidget } from '@isg/ui-kit';
import { t } from '../i18n/index.js';

// Built at render time, never at module scope: t() must run after boot.
function suggestions() {
  return [
    t('assistant.suggestions.pending'),
    t('assistant.suggestions.expiring'),
    t('assistant.suggestions.search'),
    t('assistant.suggestions.missing'),
    t('assistant.suggestions.gate'),
  ];
}

export function renderAIAssistant(container) {
  renderAgentWidget(container, {
    appSlug: 'customer_certs',
    title: t('assistant.title'),
    placeholder: t('assistant.placeholder'),
    suggestions: suggestions(),
  });
}
